export * from './card-heading-compact.tsx'
